import { Pipe, PipeTransform } from '@angular/core';
import { CompleteMedicalCareStruct } from '../../services/structs/orchestrator-patient/complete-medical-care.struct';
import { SadtStatusEnum } from '../../enum/sadt-status.enum';

@Pipe({
    name: 'filterExamsSuspension',
    standalone: false
})
export class FilterExamsSuspensionPipe implements PipeTransform {

  transform(medicalCare: CompleteMedicalCareStruct, isHistory: boolean, idCurrentMedicalCare?: number): any[] {
    return isHistory ? 
      medicalCare.medicalCareSadt.filter(x => x.idStatus == SadtStatusEnum.Suspenso && x.idMedicalCareSuspended == idCurrentMedicalCare)
      : medicalCare.medicalCareSadt.filter(x => x.canSuspend);
  }
}

